import React from 'react';

import styles from '../../styles/timebase-testseries.module.scss';

function ActionButton({ item, handleRegister }) {
  const date = new Date();
  const resultTime = item?.resultTime;
  const currenttime = Date.parse(date);
  const itemStatus = item?.userTestStatus;
  if (itemStatus === 'REGISTER') {
    return (
      <div className={styles.register} onClick={handleRegister(item)}>
        Register
      </div>
    );
  }

  if (itemStatus === 'START_NOW') {
    return (
      <div className={styles.startnow} onClick={handleRegister(item)}>
        Start Now {'>'}
      </div>
    );
  }
  if (itemStatus === 'REGISTERED') {
    return <div className={styles.registered}>Registered</div>;
  }
  if (itemStatus === 'COMPLETED') {
    return (
      <div className={styles.register} onClick={handleRegister(item)}>
        {currenttime > resultTime && `${'View Result >'}`}
      </div>
    );
  }
  if (itemStatus === 'INCOMPLETE') {
    return (
      <div className={styles.register} onClick={handleRegister(item)}>
        Resume
      </div>
    );
  }
  if (itemStatus === 'Registration time is over now') {
    return (
      <div className={styles.registered} style={{ cursor: 'default' }}>
        Reg Closed
      </div>
    );
  }
  return null;
}
export default ActionButton;
